import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import Paginator from '@dc/ui-library/src/organisms/Paginator/Paginator.js';
import { setCurrentPaginatorPage } from '../../../appState/ducks/listingPagePagination';
import { getCurrentPaginatorPage } from './helpers';
import { fetchListingPageData } from '../../../appState/ducks/network';

function onLinkClick(url, pageNumber) {
  if (getCurrentPaginatorPage().label === pageNumber) {
    return;
  }
  window.appState.dispatch(setCurrentPaginatorPage(pageNumber));
  const whatChanged = 'pagination';
  window.appState.dispatch(fetchListingPageData(whatChanged));
}

function mapStateToProps(state) {
  const currentPaginatorPage = getCurrentPaginatorPage();
  const pageList = state.listingPage.pagination.pageList;
  const currentPageIndex = pageList.findIndex(
    page => page.label === currentPaginatorPage.label
  );

  // This calculation is here for situation when pageList would contain more than 5 pages, we need
  // to render only 5 pages in paginator.
  let startIndex = currentPageIndex - 2; // slice start index is inclusive
  let endIndex = currentPageIndex + 3; // slice end index is exclusive (1 more)

  if (startIndex < 0) {
    endIndex += Math.abs(startIndex);
    startIndex = 0;
  }

  let additionalStart = pageList.length - (currentPageIndex + 3);
  if (additionalStart < 0) {
    additionalStart = Math.abs(additionalStart);
    // Start index can not be less than 0 after applying additionalStart
    startIndex = (startIndex - additionalStart < 0) ? 0 : (startIndex - additionalStart);
  }

  let pagesList = state.listingPage.pagination.pageList.slice(
    startIndex,
    endIndex
  );

  if (pagesList.length === 1) {
    pagesList = [];
  }

  return {
    pagesList
  };
}

export default function initListingPaginator() {
  const ConnectedPaginator = connect(mapStateToProps)(Paginator);
  const mountEl = document.querySelector('[data-component="list-page-paginator"]');

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedPaginator
          onLinkClick={onLinkClick}
        />
      </Provider>, mountEl
    );
  }
}
